import { render, staticRenderFns } from "./agentOrder.vue?vue&type=template&id=3d879ca8&scoped=true&"
import script from "./agentOrder.vue?vue&type=script&lang=js&"
export * from "./agentOrder.vue?vue&type=script&lang=js&"
import style0 from "./agentOrder.vue?vue&type=style&index=0&id=3d879ca8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d879ca8",
  null
  
)

export default component.exports